module.exports = __webpack_public_path__ + "img/deco-sprite-1x.34fedb73.png";